import { ref } from 'vue'
import type { MatrixMembershipStatus } from './membershipProtocol'

const states = new Map<string, MatrixMembershipStatus>()
export const membershipRevision = ref(0)
const key = (roomId: string, userId?: string | null) => `${userId ?? ''}:${roomId}`

export function setMembershipStatus(roomId: string, state: MatrixMembershipStatus, userId?: string | null): void {
  states.set(key(roomId, userId), state)
  membershipRevision.value += 1
}

export function getMembershipStatus(roomId: string, userId?: string | null): MatrixMembershipStatus | undefined {
  return states.get(key(roomId, userId))
}

export function clearMembershipStatus(roomId: string, userId?: string | null): void {
  states.delete(key(roomId, userId))
  membershipRevision.value += 1
}
